import { ActivityAlertSettingsDatasource } from "@core/data/datasources/activity-alert-settings.datasource";
import { FallbackError } from "@core/domain/errors/fallback.error";
import { ActivityAlertSettings } from "@core/domain/models/activity-alert-settings.model";
import { Either } from "@core/domain/types/either";
import { inject, injectable } from "inversify";

@injectable()
export class ActivityAlertSettingsRepository {
    constructor(
        @inject(ActivityAlertSettingsDatasource)
        private readonly datasource: ActivityAlertSettingsDatasource,
    ) {}

    fetchMy(): Promise<Either<FallbackError, ActivityAlertSettings>> {
        return this.datasource.fetchMy();
    }

    updateMy(
        settings: ActivityAlertSettings,
    ): Promise<Either<FallbackError, ActivityAlertSettings>> {
        return this.datasource.updateMy(settings);
    }
}
